import "./Homepage.css";
import Hero from "./Hero";
import TrustedBy from "./TrustedBy";
import Challenge from "./Challenge";
import HowItWorks from "./HowItWorks";
import WhyEssy from "./WhyEssy";
import BePart from "./BePart";

export default function Homepage() {
  return (
    <>
      <Hero />
      <TrustedBy />
      <Challenge />
      <HowItWorks />
      <WhyEssy />
      <BePart />
    </>
  );
}
